import { ApiClient } from "../api.client";
import { GetReportsRequest, GetReportsResponse } from "./types";

const ReportsApi = {
  getReports(params: GetReportsRequest) {
    return ApiClient.get<GetReportsResponse>("/admin/reports", {
      params,
    });
  },
};

export { ReportsApi };
